// context/MultiProductContext.jsx
// Context provider for multi-product creator
// Provides shared state and functions to child components

import React, { createContext, useContext } from "react";

// Create the context
export const MultiProductContext = createContext(null);

// Custom hook for consuming the context
export const useMultiProduct = () => {
  const context = useContext(MultiProductContext);

  if (!context) {
    throw new Error(
      "useMultiProduct must be used within a MultiProductCreator"
    );
  }

  return context;
};

// Context shape documentation (for TypeScript users or documentation)
/**
 * @typedef {Object} MultiProductContextValue
 * @property {Array} tabs - Array of product tabs
 * @property {string|null} activeTabId - Currently active tab ID
 * @property {Object|null} activeTab - Currently active tab object
 * @property {Function} addTab - Add a new tab
 * @property {Function} removeTab - Remove a tab by ID
 * @property {Function} duplicateTab - Duplicate a tab
 * @property {Function} updateTabData - Update tab data
 * @property {Function} setActiveTab - Set active tab by ID
 * @property {Function} handleSaveProduct - Save a product
 * @property {Array} categories - Available categories
 * @property {Array} branches - Available branches
 * @property {Object} user - Current user object
 * @property {Array} displayMedia - Current tab's display media
 * @property {Object} mediaFiles - Current tab's media files
 * @property {Function} handleMediaChange - Handle media change
 * @property {Function} handleMediaUpload - Handle media upload
 * @property {Function} handleMediaDelete - Handle media delete
 */

export default MultiProductContext;
